export default "/_next/static/chunks/fonts/MADEMirage-1361252632dc2075ab858b2a8a0be864.woff2";